// eslint-disable-next-line no-undef
const config = __CONFIG__

export default config
